import{__require as r}from"./global-this.js";import{__require as e}from"./is-callable.js";var a,i;function t(){if(i)return a;i=1;var t=r(),o=e(),s=t.WeakMap;return a=o(s)&&/native code/.test(String(s))}export{t as __require};
//# sourceMappingURL=weak-map-basic-detection.js.map
